var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs12 sm5 text-xs-center flexstuff",class:[_vm.bct?'md4':'text-md-right','fs'+_vm.fsize]},[_vm._t("ico")],2),_vm._v(" "),_c('v-flex',{staticClass:"xs12 sm7 vcenter",class:{'md8':_vm.bct}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38814ea6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconTable.vue
// module id = 400
// module chunks = 0